import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiEndpoints } from "../../services/apiConfig";



export const fetchLaunchedDetailPerDay = createAsyncThunk(
  "campaignAnalytics/fetchLaunchedDetailPerDay",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(apiEndpoints.fetchLaunchedDetailPerDay, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
  {
    condition: (_, { getState }) => {
      const { campaignAnalytics } = getState();
      // ❌ if data already exists, skip API call
      if (campaignAnalytics.data && campaignAnalytics.data.length > 0) {
        return false;
      }
      return true;
    },
  }
);

export const fetchSendingSettings = createAsyncThunk(
  "campaignAnalytics/fetchSendingSettings",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(apiEndpoints.fetchSendingSettings, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const checkDomain = createAsyncThunk(
  "campaignAnalytics/checkDomain",
  async (email, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${apiEndpoints.checkDomain}?email=${encodeURIComponent(email)}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const campaignAnalyticsSlice = createSlice({
  name: "campaignAnalytics",
  initialState: {
    data: [],
    sendingSettings: {},
    domainCheck: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLaunchedDetailPerDay.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLaunchedDetailPerDay.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchLaunchedDetailPerDay.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchSendingSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSendingSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.sendingSettings = action.payload;
      })
      .addCase(fetchSendingSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(checkDomain.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(checkDomain.fulfilled, (state, action) => {
        state.loading = false;
        state.domainCheck = action.payload;
      })
      .addCase(checkDomain.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default campaignAnalyticsSlice.reducer;
